const getInningsTotal = (inningsData) => {
  const { runs, wickets, closure_name, overs } = inningsData;
  return `${runs}${wickets !== '10' ? `/${wickets}` : ''} ${
    closure_name !== 'complete' ? closure_name : ''
  } (${overs} overs)`;
};

export default getInningsTotal;
